import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatBadge} from '@angular/material/badge';
import {MatIcon} from '@angular/material/icon';
import {ComponentLibSectionComponent} from '@aviary/components/component-lib/section/component-lib-section.component';

@Component({
  selector: 'mx-component-lib-badges',
  templateUrl: './component-lib-badges.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ComponentLibSectionComponent, MatBadge, MatIcon]
})
export class ComponentLibBadgesComponent {}
